import {get, post, del} from './http';

export type Share = {
  id: string;
  shared_with_email: string;
  permission: 'view' | 'act';
  shared_by: string;
  created_at: string;
};

export type CreateShareRequest = {
  email: string;
  permission: 'view' | 'act';
};

export type Analyst = {
  auth0_subject: string;
  email: string;
  display_name: string;
};

export const jobSharesApi = {
  list: async (jobId: string) => get<Share[]>(`/jobs/${jobId}/shares`),
  create: async (jobId: string, body: CreateShareRequest) =>
    post<CreateShareRequest, Share>(`/jobs/${jobId}/shares`, body),
  remove: async (jobId: string, shareId: string) => del(`/jobs/${jobId}/shares/${shareId}`)
};

export const folderSharesApi = {
  list: async (folderId: string) => get<Share[]>(`/folders/${folderId}/shares`),
  create: async (folderId: string, body: CreateShareRequest) =>
    post<CreateShareRequest, Share>(`/folders/${folderId}/shares`, body),
  remove: async (folderId: string, shareId: string) => del(`/folders/${folderId}/shares/${shareId}`)
};

export const analystsApi = {
  search: async (q?: string) => get<Analyst[]>('/analysts', q ? {q} : undefined)
};
